import HowItWorks from "@/components/HowItWorks";
import StatsCounter from "@/components/StatsCounter";
import TrustBar from "@/components/TrustBar";
import FAQAccordion from "@/components/FAQAccordion";
import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function HowItWorksPage() {
    return (
        <>
            <Seo
                title="How it works"
                description="From free eligibility check to paid compensation in 4 simple steps. See exactly how a ClaimHub UK claim works — plain English, no jargon, full FCA-aware transparency."
                path="/how-it-works"
            />
            <section className="relative overflow-hidden bg-navy-900 text-white">
                <div className="absolute inset-0 bg-mesh-emerald" />
                <div className="absolute inset-0 grid-bg-dark opacity-25" />
                <div className="container-x relative py-20 lg:py-28">
                    <span className="text-eyebrow-light">The process</span>
                    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-display font-bold tracking-tight">
                        How a ClaimHub UK claim actually works.
                    </h1>
                    <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
                        Plain English, zero jargon, total transparency. Here&apos;s exactly what happens from the moment you start your free check.
                    </p>
                    <div className="mt-8">
                        <Link to="/claim" className="btn-primary">Start your free check <ArrowRight className="w-4 h-4" /></Link>
                    </div>
                </div>
            </section>
            <TrustBar />
            <HowItWorks />
            <StatsCounter />
            <FAQAccordion />
        </>
    );
}
